import { Component, input } from '@angular/core';

export type DeieItem = {
  libelle: string;
  actif: boolean;
};

@Component({
  selector: 'app-installation-deie-panel',
  templateUrl: './installation-deie-panel.html',
  styleUrl: './installation-deie-panel.css',
})
export class InstallationDeiePanelComponent {
  readonly date = input('');
  readonly items = input<DeieItem[]>([]);
}
